import { IVendorCommentData } from 'types/order/comment/IVendorComment';
import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';

export interface ICommentsState {
  comments: { [orderId: string]: IVendorCommentData[] };
  getCommentsFetchStatus: IFetchStatus;
  getCommentsError?: string;
  postCommentFetchStatus: IFetchStatus;
  postCommentError?: string;
}

export const commentsInitialState: ICommentsState = {
  comments: {},
  getCommentsFetchStatus: createDefaultFetch(),
  postCommentFetchStatus: createDefaultFetch(),
};
